"use client";

import * as React from "react";
// next-themes 0.4 exports the props type from the package root; the old
// "next-themes/dist/types" subpath no longer exists.
import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from "next-themes";
import { useEffect, useState } from "react";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <></>;
  }

  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
